import React from 'react';
import { getUserType } from '../utils/authStorage';
import AdminDashboard from './AdminDashboard';
import TeamLeadDashboard from './TeamLeadDashboard';
import RecruiterDashboard from './RecruiterDashboard';

function RoleDashboard() {
  const userType = getUserType();
  if (userType === 'Admin') return <AdminDashboard />;
  if (userType === 'TeamLead') return <TeamLeadDashboard />;
  return <RecruiterDashboard />;
}

export default RoleDashboard;
